import { render } from "./AdminPano.vue?vue&type=template&id=23ff6e51&ts=true&lang=pug"
import script from "./AdminPano.vue?vue&type=script&lang=ts"
export * from "./AdminPano.vue?vue&type=script&lang=ts"

import "./AdminPano.vue?vue&type=style&index=0&id=23ff6e51&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__